import React from 'react'
import MenuContext from 'widgets/navigation/MenuContext'

export default function useMenu () {
  return React.useContext(MenuContext)
}
